import { Outlet } from 'react-router-dom'
import { PublicHeader } from './public-header'
import { PublicFooter } from './public-footer'

export function LandingLayout() {
  return (
    <div className="marketing-experience min-h-screen bg-background flex flex-col">
      <a
        href="#main-content"
        className="sr-only focus:not-sr-only focus:absolute focus:z-50 focus:top-2 focus:left-2 focus:px-4 focus:py-2 focus:bg-background focus:text-foreground focus:rounded focus:shadow-md focus:outline-none focus:ring-2 focus:ring-ring"
      >
        Skip to content
      </a>
      <PublicHeader hasHeroSection={true} />
      <main id="main-content" className="flex-1 flex flex-col">
        <Outlet />
      </main>
      <PublicFooter />
    </div>
  );
}
